// Mock data for luxury real estate properties

export const properties = [
  {
    id: 1,
    title: {
      he: "פנטהאוז יוקרתי עם נוף לים",
      fr: "Penthouse de luxe avec vue mer",
      en: "Luxury Penthouse with Sea View"
    },
    type: "penthouse",
    city: "Netanya",
    price: 12500000,
    surface: 350,
    rooms: 6,
    bathrooms: 4,
    description: {
      he: "פנטהאוז יוקרתי עם נוף פנורמי לים התיכון, גימורים ברמה הגבוהה ביותר",
      fr: "Penthouse luxueux avec vue panoramique sur la Méditerranée, finitions haut de gamme",
      en: "Luxurious penthouse with panoramic Mediterranean sea view, highest quality finishes"
    },
    images: [
      "https://images.unsplash.com/photo-1565623833408-d77e39b88af6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwZW50aG91c2V8ZW58MHx8fHwxNzcxODU2MzQxfDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1568115286680-d203e08a8be6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwZW50aG91c2V8ZW58MHx8fHwxNzcxODU2MzQxfDA&ixlib=rb-4.1.0&q=85"
    ],
    status: "sale",
    featured: true,
    virtualTour: "https://example.com/tour/1"
  },
  {
    id: 2,
    title: {
      he: "וילה מודרנית בירושלים",
      fr: "Villa moderne à Jérusalem",
      en: "Modern Villa in Jerusalem"
    },
    type: "villa",
    city: "Jerusalem",
    price: 18000000,
    surface: 520,
    rooms: 8,
    bathrooms: 6,
    description: {
      he: "וילה מודרנית ומרווחת בשכונה יוקרתית בירושלים",
      fr: "Villa moderne et spacieuse dans un quartier prestigieux de Jérusalem",
      en: "Modern and spacious villa in a prestigious Jerusalem neighborhood"
    },
    images: [
      "https://images.unsplash.com/photo-1702411200201-3061d0eea802?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwZW50aG91c2V8ZW58MHx8fHwxNzcxODU2MzQxfDA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/6970051/pexels-photo-6970051.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    ],
    status: "sale",
    featured: true,
    virtualTour: "https://example.com/tour/2"
  },
  {
    id: 3,
    title: {
      he: "דירת יוקרה בתל אביב",
      fr: "Appartement de luxe à Tel Aviv",
      en: "Luxury Apartment in Tel Aviv"
    },
    type: "apartment",
    city: "Tel Aviv",
    price: 8500000,
    surface: 180,
    rooms: 4,
    bathrooms: 3,
    description: {
      he: "דירת יוקרה במגדל יוקרתי בלב תל אביב",
      fr: "Appartement de luxe dans une tour prestigieuse au cœur de Tel Aviv",
      en: "Luxury apartment in a prestigious tower in the heart of Tel Aviv"
    },
    images: [
      "https://images.unsplash.com/photo-1677553512940-f79af72efd1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwZW50aG91c2V8ZW58MHx8fHwxNzcxODU2MzQxfDA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/7031712/pexels-photo-7031712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    ],
    status: "sale",
    featured: false,
    virtualTour: "https://example.com/tour/3"
  },
  {
    id: 4,
    title: {
      he: "פנטהאוז להשכרה ברעננה",
      fr: "Penthouse à louer à Raanana",
      en: "Penthouse for Rent in Raanana"
    },
    type: "penthouse",
    city: "Raanana",
    price: 25000,
    surface: 280,
    rooms: 5,
    bathrooms: 3,
    description: {
      he: "פנטהאוז מהמם להשכרה באזור יוקרתי ברעננה",
      fr: "Penthouse magnifique à louer dans un quartier prestigieux de Raanana",
      en: "Stunning penthouse for rent in a prestigious area of Raanana"
    },
    images: [
      "https://images.unsplash.com/photo-1763238638501-26e12ba0fc74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxjb2FzdGFsJTIwdmlld3xlbnwwfHx8fDE3NzE4NTYzNDV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/35284070/pexels-photo-35284070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    ],
    status: "rent",
    featured: true,
    virtualTour: "https://example.com/tour/4"
  },
  {
    id: 5,
    title: {
      he: "דירה יוקרתית להשכרה בנתניה",
      fr: "Appartement de luxe à louer à Netanya",
      en: "Luxury Apartment for Rent in Netanya"
    },
    type: "apartment",
    city: "Netanya",
    price: 18000,
    surface: 160,
    rooms: 4,
    bathrooms: 2,
    description: {
      he: "דירה מרהיבה עם נוף לים, זמינה להשכרה",
      fr: "Appartement magnifique avec vue mer, disponible à la location",
      en: "Stunning apartment with sea view, available for rent"
    },
    images: [
      "https://images.unsplash.com/photo-1759250450501-d4f31a5a6ce1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjb2FzdGFsJTIwdmlld3xlbnwwfHx8fDE3NzE4NTYzNDV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1764319524298-d66cbd814d56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjb2FzdGFsJTIwdmlld3xlbnwwfHx8fDE3NzE4NTYzNDV8MA&ixlib=rb-4.1.0&q=85"
    ],
    status: "rent",
    featured: false,
    virtualTour: "https://example.com/tour/5"
  },
  {
    id: 6,
    title: {
      he: "וילה יוקרתית בנתניה",
      fr: "Villa de luxe à Netanya",
      en: "Luxury Villa in Netanya"
    },
    type: "villa",
    city: "Netanya",
    price: 22000000,
    surface: 600,
    rooms: 9,
    bathrooms: 7,
    description: {
      he: "וילה פרטית מדהימה עם בריכה וגינה מעוצבת",
      fr: "Villa privée exceptionnelle avec piscine et jardin paysager",
      en: "Exceptional private villa with pool and landscaped garden"
    },
    images: [
      "https://images.pexels.com/photos/36128398/pexels-photo-36128398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1761208986871-6d48a954f14a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxjb2FzdGFsJTIwdmlld3xlbnwwfHx8fDE3NzcxODU2MzQ1fDA&ixlib=rb-4.1.0&q=85"
    ],
    status: "sale",
    featured: true,
    virtualTour: "https://example.com/tour/6"
  }
];

export const cities = [
  { value: "Netanya", label: { he: "נתניה", fr: "Netanya", en: "Netanya" } },
  { value: "Jerusalem", label: { he: "ירושלים", fr: "Jérusalem", en: "Jerusalem" } },
  { value: "Tel Aviv", label: { he: "תל אביב", fr: "Tel Aviv", en: "Tel Aviv" } },
  { value: "Raanana", label: { he: "רעננה", fr: "Raanana", en: "Raanana" } }
];

export const propertyTypes = [
  { value: "all", label: { he: "הכל", fr: "Tous", en: "All" } },
  { value: "penthouse", label: { he: "פנטהאוז", fr: "Penthouse", en: "Penthouse" } },
  { value: "villa", label: { he: "וילה", fr: "Villa", en: "Villa" } },
  { value: "apartment", label: { he: "דירה", fr: "Appartement", en: "Apartment" } }
];

export const translations = {
  he: {
    navigation: {
      home: "בית",
      sale: "למכירה",
      rent: "להשכרה",
      exceptional: "נכסי יוקרה",
      about: "אודות",
      contact: "צור קשר"
    },
    hero: {
      title: "נדל״ן יוקרתי בישראל",
      subtitle: "גלו את הנכסים המיוחדים ביותר בנתניה, ירושלים, תל אביב ורעננה",
      cta: "חפשו את הנכס שלכם"
    },
    search: {
      title: "חיפוש נכסים",
      type: "סוג נכס",
      city: "עיר",
      priceRange: "טווח מחירים",
      minPrice: "מחיר מינימום",
      maxPrice: "מחיר מקסימום",
      minSurface: "שטח מינימום",
      search: "חפש",
      reset: "אפס"
    },
    property: {
      rooms: "חדרים",
      bathrooms: "אמבטיות",
      surface: "מ״ר",
      viewDetails: "לפרטים נוספים",
      virtualTour: "סיור וירטואלי",
      contact: "צור קשר",
      forSale: "למכירה",
      forRent: "להשכרה",
      perMonth: "לחודש"
    },
    contact: {
      title: "צרו קשר",
      subtitle: "אנחנו כאן לעזור לכם למצוא את הנכס המושלם",
      name: "שם מלא",
      email: "אימייל",
      phone: "טלפון",
      message: "הודעה",
      send: "שלח הודעה"
    },
    footer: {
      aboutTitle: "אודות bayitfull",
      aboutText: "ונסה בנאים קקון - יועצת הנדל״ן שלך למכירה והשכרה של נכסי יוקרה בישראל",
      contactTitle: "צור קשר",
      followTitle: "עקבו אחרינו",
      rights: "כל הזכויות שמורות"
    },
    team: {
      title: "הצוות שלנו",
      subtitle: "מומחים במקצועם עם ניסיון רב בשוק הנדל״ן היוקרתי"
    }
  },
  fr: {
    navigation: {
      home: "Accueil",
      sale: "Vente",
      rent: "Location",
      exceptional: "Propriétés d'Exception",
      about: "À Propos",
      contact: "Contact"
    },
    hero: {
      title: "Immobilier de Luxe en Israël",
      subtitle: "Découvrez les propriétés les plus exceptionnelles à Netanya, Jérusalem, Tel Aviv et Raanana",
      cta: "Trouvez votre propriété"
    },
    search: {
      title: "Recherche de Propriétés",
      type: "Type de bien",
      city: "Ville",
      priceRange: "Fourchette de prix",
      minPrice: "Prix minimum",
      maxPrice: "Prix maximum",
      minSurface: "Surface minimum",
      search: "Rechercher",
      reset: "Réinitialiser"
    },
    property: {
      rooms: "Chambres",
      bathrooms: "Salles de bain",
      surface: "m²",
      viewDetails: "Voir détails",
      virtualTour: "Visite virtuelle",
      contact: "Contact",
      forSale: "À vendre",
      forRent: "À louer",
      perMonth: "/mois"
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour vous aider à trouver la propriété parfaite",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      message: "Message",
      send: "Envoyer le message"
    },
    footer: {
      aboutTitle: "À Propos de bayitfull",
      aboutText: "Vanessa Benaim Kakun - Votre conseillère immobilière de confiance pour la vente et la location de propriétés d'exception en Israël",
      contactTitle: "Contact",
      followTitle: "Suivez-nous",
      rights: "Tous droits réservés"
    },
    team: {
      title: "Notre Équipe",
      subtitle: "Des experts passionnés avec une vaste expérience du marché immobilier de luxe"
    }
  },
  en: {
    navigation: {
      home: "Home",
      sale: "Sale",
      rent: "Rent",
      exceptional: "Exceptional Properties",
      about: "About",
      contact: "Contact"
    },
    hero: {
      title: "Luxury Real Estate in Israel",
      subtitle: "Discover the most exceptional properties in Netanya, Jerusalem, Tel Aviv and Raanana",
      cta: "Find Your Property"
    },
    search: {
      title: "Property Search",
      type: "Property type",
      city: "City",
      priceRange: "Price range",
      minPrice: "Minimum price",
      maxPrice: "Maximum price",
      minSurface: "Minimum surface",
      search: "Search",
      reset: "Reset"
    },
    property: {
      rooms: "Rooms",
      bathrooms: "Bathrooms",
      surface: "sqm",
      viewDetails: "View Details",
      virtualTour: "Virtual Tour",
      contact: "Contact",
      forSale: "For Sale",
      forRent: "For Rent",
      perMonth: "/month"
    },
    contact: {
      title: "Contact Us",
      subtitle: "We're here to help you find the perfect property",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send Message"
    },
    footer: {
      aboutTitle: "About bayitfull",
      aboutText: "Vanessa Benaim Kakun - Your trusted real estate advisor for sales and rentals of exceptional properties in Israel",
      contactTitle: "Contact",
      followTitle: "Follow Us",
      rights: "All rights reserved"
    },
    team: {
      title: "Our Team",
      subtitle: "Passionate experts with extensive experience in the luxury real estate market"
    }
  },
  ru: {
    navigation: {
      home: "Главная",
      sale: "Продажа",
      rent: "Аренда",
      exceptional: "Элитная Недвижимость",
      about: "О Нас",
      contact: "Контакты"
    },
    hero: {
      title: "Элитная Недвижимость в Израиле",
      subtitle: "Откройте для себя самую исключительную недвижимость в Нетании, Иерусалиме, Тель-Авиве и Раанане",
      cta: "Найдите Вашу Недвижимость"
    },
    search: {
      title: "Поиск Недвижимости",
      type: "Тип недвижимости",
      city: "Город",
      priceRange: "Диапазон цен",
      minPrice: "Минимальная цена",
      maxPrice: "Максимальная цена",
      minSurface: "Минимальная площадь",
      search: "Искать",
      reset: "Сбросить"
    },
    property: {
      rooms: "Комнаты",
      bathrooms: "Ванные",
      surface: "кв.м",
      viewDetails: "Подробнее",
      virtualTour: "Виртуальный тур",
      contact: "Связаться",
      forSale: "Продажа",
      forRent: "Аренда",
      perMonth: "/месяц"
    },
    contact: {
      title: "Свяжитесь с Нами",
      subtitle: "Мы здесь, чтобы помочь вам найти идеальную недвижимость",
      name: "Полное имя",
      email: "Email",
      phone: "Телефон",
      message: "Сообщение",
      send: "Отправить сообщение"
    },
    footer: {
      aboutTitle: "О bayitfull",
      aboutText: "Ванесса Бенаим Какун - Ваш надежный консультант по недвижимости для продажи и аренды элитной недвижимости в Израиле",
      contactTitle: "Контакты",
      followTitle: "Следите за Нами",
      rights: "Все права защищены"
    },
    team: {
      title: "Наша Команда",
      subtitle: "Увлеченные эксперты с обширным опытом на рынке элитной недвижимости"
    }
  }
};

export const collaborators = [
  {
    id: 1,
    name: 'Vanessa Benaim Kakun',
    name_he: 'ונסה בנאים קקון',
    name_ru: 'Ванесса Бенаим Какун',
    role: 'Founder - Real Estate Advisor',
    role_fr: 'Fondatrice - Conseillère Immobilière',
    role_he: 'מייסדת - יועצת נדל״ן',
    role_ru: 'Основатель - Консультант по Недвижимости',
    phone: '052 357 0058',
    email: 'vanessa.kakun@gmail.com',
    languages: 'Français, Hébreu, English, Русский',
    languages_he: 'צרפתית, עברית, אנגלית, רוסית',
    languages_ru: 'Французский, Иврит, Английский, Русский',
    photo: 'https://customer-assets.emergentagent.com/job_netanya-elite-homes/artifacts/53bi7cuj_IMG_0239.png'
  }
];
